<template>
  <div id="DepositGroup">
    <loading v-if="loadingRender"></loading>
    <panel Title="فرم پرداخت گروهی" Des="از طریق این فرم می توانید به صورت گروهی اقساط و سپرده های خود را به یکجا پرداخت کنید" :IsBtnBack="true" :IsBtnClose="false" ClassCustom="bg-dark-Custom text-right"></panel>
    <net-pa-card :IsMinus="true" :IdElement="'MyLoan'">
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-gift"></i> {{$GetIsAnbohSaz()=='false'?'تسهیلات خودم':'پروژه های من'}}</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12 text-left">
            <div class="deposit-group-cards" dir="rtl">
              <p v-if="!LoanList.length" class="deposit-group-cards__empty">
                اطلاعاتی یافت نشد
              </p>
              <template v-else>
                <div class="deposit-group-cards__toolbar">
                  <input
                    v-model="loanCardSearch"
                    type="search"
                    class="form-control deposit-group-cards__search"
                    placeholder=" جستجو"
                    aria-label="جستجو در تسهیلات"
                  />
                </div>
                <p
                  v-if="filteredLoanCards.length === 0"
                  class="deposit-group-cards__empty"
                >
                  اطلاعاتی یافت نشد
                </p>
                <div v-else class="deposit-group-cards__list">
                  <article
                    v-for="(row, index) in pagedLoanCards"
                    :key="(row.id || 'loan') + '-' + index"
                    class="deposit-group-card"
                  >
                    <div class="deposit-group-card__header">
                      <strong class="deposit-group-card__name">{{
                        row.desNoe ||
                        ($GetIsAnbohSaz() == 'false' ? 'تسهیلات' : 'قرارداد')
                      }}</strong>
                      <span v-if="row.vCode" class="deposit-group-card__badge">{{
                        row.vCode
                      }}</span>
                    </div>
                    <div class="deposit-group-card__amount">
                      <span dir="ltr">{{
                        $Comma3ragham(row.mande - row.sumMabTaeedNaShode)
                      }}</span>
                      <small>مانده</small>
                    </div>
                    <div class="deposit-group-card__fields">
                      <div class="deposit-group-card__field">
                        <span>شروع اقساط</span>
                        <strong>{{ cardValue(row.tarixShoroAghsat) }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>{{
                          $GetIsAnbohSaz() == 'false'
                            ? 'مبلغ تسهیلات'
                            : 'مبلغ قرارداد'
                        }}</span>
                        <strong dir="ltr">{{
                          $Comma3ragham(row.mablaghVam)
                        }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>مبلغ قسط</span>
                        <strong dir="ltr">{{
                          $Comma3ragham(row.mablaghGhestVam)
                        }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>مجموع معوق</span>
                        <strong dir="ltr">{{
                          $Comma3ragham(row.sumMabMoavaghe)
                        }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>جریمه</span>
                        <strong dir="ltr">{{
                          $Comma3ragham(row.wwwJarime == null ? 0 : row.wwwJarime)
                        }}</strong>
                      </div>
                      <div class="deposit-group-card__field deposit-group-card__field--input">
                        <span>مبلغ قابل پرداخت</span>
                        <input
                          :disabled="isLoanAmountDisabled(row)"
                          class="text-center 3ragham deposit-group-amount"
                          type="text"
                          @keypress="$ValidNumber($event, 13, false)"
                          @keyup="
                            $PutCommatoInput()
                            SumGhabelParLoan(LoanList)
                          "
                          title="برای وارد کردن مبلغ کلیک کنید"
                          v-model="row.SumGhabelPar"
                        />
                      </div>
                    </div>
                    <div class="deposit-group-actions deposit-group-card__actions">
                      <button
                        :disabled="isLoanPlanDisabled(row)"
                        type="button"
                        title="برنامه اقساط"
                        class="deposit-group-chip deposit-group-chip--plan"
                        @click="GetTaahodatRiz(row, false)"
                        data-toggle="modal"
                        data-target="#Modal-Success"
                      >
                        <i class="fa fa-list" aria-hidden="true"></i>
                        برنامه اقساط
                      </button>
                      <button
                        type="button"
                        class="deposit-group-chip deposit-group-chip--add Pointer"
                        @click="AddToCart(row, false)"
                      >
                        <i class="fas fa-shopping-bag" aria-hidden="true"></i>
                        افزودن به لیست پرداخت
                      </button>
                    </div>
                  </article>
                </div>
                <div
                  v-if="filteredLoanCards.length > cardPerPage"
                  class="deposit-group-cards__pager"
                >
                  <button
                    type="button"
                    class="deposit-group-cards__pager-btn"
                    :disabled="loanCardPage <= 1"
                    @click="loanCardPage = loanCardPage - 1"
                  >
                    قبلی
                  </button>
                  <span class="deposit-group-cards__pager-info">
                    صفحه {{ loanCardPage }} از {{ loanCardPageCount }}
                  </span>
                  <button
                    type="button"
                    class="deposit-group-cards__pager-btn"
                    :disabled="loanCardPage >= loanCardPageCount"
                    @click="loanCardPage = loanCardPage + 1"
                  >
                    بعدی
                  </button>
                </div>
              </template>
            </div>
            <div class="deposit-group-table-view">
            <vue-bootstrap4-table v-if="$store.state.renderComponentGrid" :rows="LoanList" :columns="columnsLoan" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="mande" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.mande - props.row.sumMabTaeedNaShode) }}</p>
              </template>
              <template slot="mablaghVam" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghVam) }}
                </p>
              </template>
              <template slot="sumMabMoavaghe" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.sumMabMoavaghe) }}
                </p>
              </template>
              <template slot="mablaghGhestVam" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghGhestVam) }}
                </p>
              </template>
              <template slot="wwwJarime" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.wwwJarime == null ? 0 : props.row.wwwJarime) }}</p>
              </template>
              <template slot="SumGhabelPar" slot-scope="props">
                <input
                  :disabled="IsFixVarizGorohi==='true' || (IsFixVarizGorohiHasJarime==='true' && props.row.wwwJarime >0)?true:false"
                  class="text-center 3ragham deposit-group-amount"
                  type="text"
                  @keypress="$ValidNumber($event, 13, false)"
                  @keyup="
                    $PutCommatoInput()
                    SumGhabelParLoan(LoanList)
                  "
                  title="برای وارد کردن مبلغ کلیک کنید"
                  v-model="LoanList[props.row.vbt_id - 1].SumGhabelPar"
                />
              </template>
              <template slot="Action" slot-scope="props">
                <div class="deposit-group-actions">
                  <button :disabled="(IsFixVarizGorohiHasJarime==='true' && props.row.wwwJarime >0)" type="button" title="برنامه اقساط" class="deposit-group-chip deposit-group-chip--plan" @click="GetTaahodatRiz(props.row, false)" data-toggle="modal" data-target="#Modal-Success">
                    <i class="fa fa-list" aria-hidden="true"></i>
                    برنامه اقساط
                  </button>
                  <button type="button" class="deposit-group-chip deposit-group-chip--add Pointer" @click="AddToCart(LoanList[props.row.vbt_id - 1], false)">
                    <i class="fas fa-shopping-bag" aria-hidden="true"></i>
                    افزودن به لیست پرداخت
                  </button>
                </div>
              </template>
            </vue-bootstrap4-table>
            </div>
            <div class="deposit-group-footer">
              <div class="deposit-group-sum">
                جمع مبلغ قابل پرداخت
                <strong>{{ $Comma3ragham(SumAllGhabelParLoan) }}</strong>
              </div>
              <button type="button" class="deposit-group-chip deposit-group-chip--add-all Pointer" @click="AllAddToCart(LoanList)">
                <i class="fas fa-plus" aria-hidden="true"></i>
                {{$GetIsAnbohSaz()=='false'?'افزودن همه تسهیلات به لیست پرداخت':'افزودن همه پروژه ها به لیست پرداخت'}}
              </button>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>

    <net-pa-card v-if="$GetIsAnbohSaz()=='false'" :Classes="'bg-dark-Custom'" :IsMinus="true" :IdElement="'ChildsLoan'">
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-gift"></i> تسهیلات وابسته</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12 text-left">
            <div class="deposit-group-cards" dir="rtl">
              <p v-if="!ChildsLoanList.length" class="deposit-group-cards__empty">
                اطلاعاتی یافت نشد
              </p>
              <template v-else>
                <div class="deposit-group-cards__toolbar">
                  <input
                    v-model="childLoanCardSearch"
                    type="search"
                    class="form-control deposit-group-cards__search"
                    placeholder=" جستجو"
                    aria-label="جستجو در تسهیلات وابسته"
                  />
                </div>
                <p
                  v-if="filteredChildLoanCards.length === 0"
                  class="deposit-group-cards__empty"
                >
                  اطلاعاتی یافت نشد
                </p>
                <div v-else class="deposit-group-cards__list">
                  <article
                    v-for="(row, index) in pagedChildLoanCards"
                    :key="(row.id || 'child-loan') + '-' + index"
                    class="deposit-group-card"
                  >
                    <div class="deposit-group-card__header">
                      <strong class="deposit-group-card__name">{{
                        row.nameFamily || row.desNoe || 'تسهیلات وابسته'
                      }}</strong>
                      <span v-if="row.vCode" class="deposit-group-card__badge">{{
                        row.vCode
                      }}</span>
                    </div>
                    <div class="deposit-group-card__amount">
                      <span dir="ltr">{{
                        $Comma3ragham(row.mande - row.sumMabTaeedNaShode)
                      }}</span>
                      <small>مانده</small>
                    </div>
                    <div class="deposit-group-card__fields">
                      <div v-if="row.desNoe && row.nameFamily" class="deposit-group-card__field">
                        <span>نوع</span>
                        <strong>{{ row.desNoe }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>شروع اقساط</span>
                        <strong>{{ cardValue(row.tarixShoroAghsat) }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>مبلغ تسهیلات</span>
                        <strong dir="ltr">{{
                          $Comma3ragham(row.mablaghVam)
                        }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>مبلغ قسط</span>
                        <strong dir="ltr">{{
                          $Comma3ragham(row.mablaghGhestVam)
                        }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>مجموع معوق</span>
                        <strong dir="ltr">{{
                          $Comma3ragham(row.sumMabMoavaghe)
                        }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>جریمه</span>
                        <strong dir="ltr">{{
                          $Comma3ragham(row.wwwJarime == null ? 0 : row.wwwJarime)
                        }}</strong>
                      </div>
                      <div class="deposit-group-card__field deposit-group-card__field--input">
                        <span>مبلغ قابل پرداخت</span>
                        <input
                          :disabled="isLoanAmountDisabled(row)"
                          class="text-center 3ragham deposit-group-amount"
                          type="text"
                          @keypress="$ValidNumber($event, 13, false)"
                          @keyup="
                            $PutCommatoInput()
                            SumGhabelParChildLoan(ChildsLoanList)
                          "
                          title="برای وارد کردن مبلغ کلیک کنید"
                          v-model="row.SumGhabelPar"
                        />
                      </div>
                    </div>
                    <div class="deposit-group-actions deposit-group-card__actions">
                      <button
                        :disabled="isLoanPlanDisabled(row)"
                        type="button"
                        title="برنامه اقساط"
                        class="deposit-group-chip deposit-group-chip--plan"
                        @click="GetTaahodatRiz(row, true)"
                        data-toggle="modal"
                        data-target="#Modal-Success"
                      >
                        <i class="fa fa-list" aria-hidden="true"></i>
                        برنامه اقساط
                      </button>
                      <button
                        type="button"
                        class="deposit-group-chip deposit-group-chip--add Pointer"
                        @click="AddToCart(row, false)"
                      >
                        <i class="fas fa-shopping-bag" aria-hidden="true"></i>
                        افزودن به لیست پرداخت
                      </button>
                    </div>
                  </article>
                </div>
                <div
                  v-if="filteredChildLoanCards.length > cardPerPage"
                  class="deposit-group-cards__pager"
                >
                  <button
                    type="button"
                    class="deposit-group-cards__pager-btn"
                    :disabled="childLoanCardPage <= 1"
                    @click="childLoanCardPage = childLoanCardPage - 1"
                  >
                    قبلی
                  </button>
                  <span class="deposit-group-cards__pager-info">
                    صفحه {{ childLoanCardPage }} از {{ childLoanCardPageCount }}
                  </span>
                  <button
                    type="button"
                    class="deposit-group-cards__pager-btn"
                    :disabled="childLoanCardPage >= childLoanCardPageCount"
                    @click="childLoanCardPage = childLoanCardPage + 1"
                  >
                    بعدی
                  </button>
                </div>
              </template>
            </div>
            <div class="deposit-group-table-view">
            <vue-bootstrap4-table v-if="$store.state.renderComponentGrid" :rows="ChildsLoanList" :columns="ChildscolumnsLoan" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="mande" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.mande - props.row.sumMabTaeedNaShode) }}</p>
              </template>
              <template slot="mablaghVam" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghVam) }}
                </p>
              </template>
              <template slot="sumMabMoavaghe" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.sumMabMoavaghe) }}
                </p>
              </template>
              <template slot="mablaghGhestVam" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghGhestVam) }}
                </p>
              </template>
              <template slot="SumGhabelPar" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.SumGhabelPar) }}
                </p>
              </template>
              <template slot="wwwJarime" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.wwwJarime == null ? 0 : props.row.wwwJarime) }}
                </p>
              </template>
              <template slot="SumGhabelPar" slot-scope="props">
                <input
                :disabled="IsFixVarizGorohi==='true'|| (IsFixVarizGorohiHasJarime==='true' && props.row.wwwJarime >0)?true:false"
                  class="text-center 3ragham deposit-group-amount"
                  type="text"
                  @keypress="$ValidNumber($event, 13, false)"
                  @keyup="
                    $PutCommatoInput()
                    SumGhabelParChildLoan(ChildsLoanList)
                  "
                  title="برای وارد کردن مبلغ کلیک کنید"
                  v-model="ChildsLoanList[props.row.vbt_id - 1].SumGhabelPar"
                />
              </template>
              <template slot="Action" slot-scope="props">
                <div class="deposit-group-actions">
                  <button :disabled="(IsFixVarizGorohiHasJarime==='true' && props.row.wwwJarime >0)" type="button" title="برنامه اقساط" class="deposit-group-chip deposit-group-chip--plan" @click="GetTaahodatRiz(props.row, true)" data-toggle="modal" data-target="#Modal-Success">
                    <i class="fa fa-list" aria-hidden="true"></i>
                    برنامه اقساط
                  </button>
                  <button type="button" class="deposit-group-chip deposit-group-chip--add Pointer" @click="AddToCart(ChildsLoanList[props.row.vbt_id - 1], false)">
                    <i class="fas fa-shopping-bag" aria-hidden="true"></i>
                    افزودن به لیست پرداخت
                  </button>
                </div>
              </template>
            </vue-bootstrap4-table>
            </div>
            <div class="deposit-group-footer">
              <div class="deposit-group-sum">
                جمع مبلغ قابل پرداخت
                <strong>{{ $Comma3ragham(SumAllGhabelParChildLoan) }}</strong>
              </div>
              <button type="button" class="deposit-group-chip deposit-group-chip--add-all Pointer" @click="AllAddToCart(ChildsLoanList)">
                <i class="fas fa-plus" aria-hidden="true"></i>
                افزودن همه تسهیلات به لیست پرداخت
              </button>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>

    <net-pa-card v-if="$GetIsAnbohSaz()=='false'" :IsMinus="true" :IdElement="'MyAccounts'" :IsCollapse="true">
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-list"></i> حساب ها خودم</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12">
            <div class="deposit-group-cards" dir="rtl">
              <p v-if="!AccountList.length" class="deposit-group-cards__empty">
                اطلاعاتی یافت نشد
              </p>
              <template v-else>
                <div class="deposit-group-cards__toolbar">
                  <input
                    v-model="accountCardSearch"
                    type="search"
                    class="form-control deposit-group-cards__search"
                    placeholder=" جستجو"
                    aria-label="جستجو در حساب‌ها"
                  />
                </div>
                <p
                  v-if="filteredAccountCards.length === 0"
                  class="deposit-group-cards__empty"
                >
                  اطلاعاتی یافت نشد
                </p>
                <div v-else class="deposit-group-cards__list">
                  <article
                    v-for="(row, index) in pagedAccountCards"
                    :key="(row.id || 'account') + '-' + index"
                    class="deposit-group-card"
                  >
                    <div class="deposit-group-card__header">
                      <strong class="deposit-group-card__name">{{
                        row.desNoe || 'حساب'
                      }}</strong>
                      <span v-if="row.vCode" class="deposit-group-card__badge">{{
                        row.vCode
                      }}</span>
                    </div>
                    <div class="deposit-group-card__amount">
                      <span dir="ltr">{{ $Comma3ragham(row.mande) }}</span>
                      <small>موجودی</small>
                    </div>
                    <div class="deposit-group-card__fields">
                      <div class="deposit-group-card__field">
                        <span>تاریخ افتتاح</span>
                        <strong>{{ cardValue(row.tarix) }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>قابل برداشت</span>
                        <strong dir="ltr">{{
                          $Comma3ragham(row.ghabelBardasht)
                        }}</strong>
                      </div>
                      <div class="deposit-group-card__field deposit-group-card__field--input">
                        <span>مبلغ واریزی</span>
                        <input
                          :disabled="IsFixVarizGorohi === 'true'"
                          class="text-center 3ragham deposit-group-amount"
                          type="text"
                          @keypress="$ValidNumber($event, 13, false)"
                          @keyup="$PutCommatoInput()"
                          title="برای وارد کردن مبلغ کلیک کنید"
                          v-model="row.MabVarizi"
                        />
                      </div>
                    </div>
                    <div class="deposit-group-actions deposit-group-card__actions">
                      <button
                        type="button"
                        title="برنامه اقساط"
                        class="deposit-group-chip deposit-group-chip--plan"
                        @click="GetTaahodatRiz(row, false)"
                        data-toggle="modal"
                        data-target="#Modal-Success"
                      >
                        <i class="fa fa-list" aria-hidden="true"></i>
                        برنامه اقساط
                      </button>
                      <button
                        type="button"
                        class="deposit-group-chip deposit-group-chip--add Pointer"
                        @click="AddToCart(row, true)"
                      >
                        <i class="fas fa-shopping-bag" aria-hidden="true"></i>
                        افزودن به لیست پرداخت
                      </button>
                    </div>
                  </article>
                </div>
                <div
                  v-if="filteredAccountCards.length > cardPerPage"
                  class="deposit-group-cards__pager"
                >
                  <button
                    type="button"
                    class="deposit-group-cards__pager-btn"
                    :disabled="accountCardPage <= 1"
                    @click="accountCardPage = accountCardPage - 1"
                  >
                    قبلی
                  </button>
                  <span class="deposit-group-cards__pager-info">
                    صفحه {{ accountCardPage }} از {{ accountCardPageCount }}
                  </span>
                  <button
                    type="button"
                    class="deposit-group-cards__pager-btn"
                    :disabled="accountCardPage >= accountCardPageCount"
                    @click="accountCardPage = accountCardPage + 1"
                  >
                    بعدی
                  </button>
                </div>
              </template>
            </div>
            <div class="deposit-group-table-view">
            <vue-bootstrap4-table :rows="AccountList" :columns="columnsAccount" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="mablaghSharj" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghSharj) }}
                </p>
              </template>
              <template slot="mande" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.mande) }}</p>
              </template>
              <template slot="ghabelBardasht" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.ghabelBardasht) }}
                </p>
              </template>
              <template slot="MabVarizi" slot-scope="props">
                <input :disabled="IsFixVarizGorohi==='true'?true:false" class="text-center 3ragham deposit-group-amount" type="text" @keypress="$ValidNumber($event, 13, false)" @keyup="$PutCommatoInput()" title="برای وارد کردن مبلغ کلیک کنید" v-model="AccountList[props.row.vbt_id - 1].MabVarizi" />
              </template>
              <template slot="Action" slot-scope="props">
                <div class="deposit-group-actions">
                  <button type="button" title="برنامه اقساط" class="deposit-group-chip deposit-group-chip--plan" @click="GetTaahodatRiz(props.row, false)" data-toggle="modal" data-target="#Modal-Success">
                    <i class="fa fa-list" aria-hidden="true"></i>
                    برنامه اقساط
                  </button>
                  <button type="button" class="deposit-group-chip deposit-group-chip--add Pointer" @click="AddToCart(AccountList[props.row.vbt_id - 1], true)">
                    <i class="fas fa-shopping-bag" aria-hidden="true"></i>
                    افزودن به لیست پرداخت
                  </button>
                </div>
              </template>
            </vue-bootstrap4-table>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>

    <net-pa-card v-if="$GetIsAnbohSaz()=='false'"  :Classes="'bg-dark-Custom'" :IsMinus="true" :IdElement="'ChildsAccount'" :IsCollapse="true">
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-list"></i> حساب ها وابسته</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-12">
            <div class="deposit-group-cards" dir="rtl">
              <p v-if="!ChildsAccountList.length" class="deposit-group-cards__empty">
                اطلاعاتی یافت نشد
              </p>
              <template v-else>
                <div class="deposit-group-cards__toolbar">
                  <input
                    v-model="childAccountCardSearch"
                    type="search"
                    class="form-control deposit-group-cards__search"
                    placeholder=" جستجو"
                    aria-label="جستجو در حساب‌های وابسته"
                  />
                </div>
                <p
                  v-if="filteredChildAccountCards.length === 0"
                  class="deposit-group-cards__empty"
                >
                  اطلاعاتی یافت نشد
                </p>
                <div v-else class="deposit-group-cards__list">
                  <article
                    v-for="(row, index) in pagedChildAccountCards"
                    :key="(row.id || 'child-account') + '-' + index"
                    class="deposit-group-card"
                  >
                    <div class="deposit-group-card__header">
                      <strong class="deposit-group-card__name">{{
                        row.nameFamily || row.desNoe || 'حساب وابسته'
                      }}</strong>
                      <span v-if="row.vCode" class="deposit-group-card__badge">{{
                        row.vCode
                      }}</span>
                    </div>
                    <div class="deposit-group-card__amount">
                      <span dir="ltr">{{ $Comma3ragham(row.mande) }}</span>
                      <small>موجودی</small>
                    </div>
                    <div class="deposit-group-card__fields">
                      <div v-if="row.desNoe && row.nameFamily" class="deposit-group-card__field">
                        <span>نوع حساب</span>
                        <strong>{{ row.desNoe }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>تاریخ افتتاح</span>
                        <strong>{{ cardValue(row.tarix) }}</strong>
                      </div>
                      <div class="deposit-group-card__field">
                        <span>قابل برداشت</span>
                        <strong dir="ltr">{{
                          $Comma3ragham(row.ghabelBardasht)
                        }}</strong>
                      </div>
                      <div class="deposit-group-card__field deposit-group-card__field--input">
                        <span>مبلغ واریزی</span>
                        <input
                          :disabled="IsFixVarizGorohi === 'true'"
                          class="text-center 3ragham deposit-group-amount"
                          type="text"
                          @keypress="$ValidNumber($event, 13, false)"
                          @keyup="$PutCommatoInput()"
                          title="برای وارد کردن مبلغ کلیک کنید"
                          v-model="row.MabVarizi"
                        />
                      </div>
                    </div>
                    <div class="deposit-group-actions deposit-group-card__actions">
                      <button
                        type="button"
                        title="برنامه اقساط"
                        class="deposit-group-chip deposit-group-chip--plan"
                        @click="GetTaahodatRiz(row, false)"
                        data-toggle="modal"
                        data-target="#Modal-Success"
                      >
                        <i class="fa fa-list" aria-hidden="true"></i>
                        برنامه اقساط
                      </button>
                      <button
                        type="button"
                        class="deposit-group-chip deposit-group-chip--add Pointer"
                        @click="AddToCart(row, true)"
                      >
                        <i class="fas fa-shopping-bag" aria-hidden="true"></i>
                        افزودن به لیست پرداخت
                      </button>
                    </div>
                  </article>
                </div>
                <div
                  v-if="filteredChildAccountCards.length > cardPerPage"
                  class="deposit-group-cards__pager"
                >
                  <button
                    type="button"
                    class="deposit-group-cards__pager-btn"
                    :disabled="childAccountCardPage <= 1"
                    @click="childAccountCardPage = childAccountCardPage - 1"
                  >
                    قبلی
                  </button>
                  <span class="deposit-group-cards__pager-info">
                    صفحه {{ childAccountCardPage }} از {{ childAccountCardPageCount }}
                  </span>
                  <button
                    type="button"
                    class="deposit-group-cards__pager-btn"
                    :disabled="childAccountCardPage >= childAccountCardPageCount"
                    @click="childAccountCardPage = childAccountCardPage + 1"
                  >
                    بعدی
                  </button>
                </div>
              </template>
            </div>
            <div class="deposit-group-table-view">
            <vue-bootstrap4-table :rows="ChildsAccountList" :columns="ChildscolumnsAccount" :config="config" :classes="classes">
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="mablaghSharj" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.mablaghSharj) }}
                </p>
              </template>
              <template slot="mande" slot-scope="props">
                <p class="text-center">{{ $Comma3ragham(props.row.mande) }}</p>
              </template>
              <template slot="ghabelBardasht" slot-scope="props">
                <p class="text-center">
                  {{ $Comma3ragham(props.row.ghabelBardasht) }}
                </p>
              </template>
              <template slot="MabVarizi" slot-scope="props">
                <input :disabled="IsFixVarizGorohi==='true'?true:false" class="text-center 3ragham deposit-group-amount" type="text" @keypress="$ValidNumber($event, 13, false)" @keyup="$PutCommatoInput()" title="برای وارد کردن مبلغ کلیک کنید" v-model="ChildsAccountList[props.row.vbt_id - 1].MabVarizi" />
              </template>
              <template slot="Action" slot-scope="props">
                <div class="deposit-group-actions">
                  <button type="button" title="برنامه اقساط" class="deposit-group-chip deposit-group-chip--plan" @click="GetTaahodatRiz(props.row, false)" data-toggle="modal" data-target="#Modal-Success">
                    <i class="fa fa-list" aria-hidden="true"></i>
                    برنامه اقساط
                  </button>
                  <button type="button" class="deposit-group-chip deposit-group-chip--add Pointer" @click="AddToCart(ChildsAccountList[props.row.vbt_id - 1], true)">
                    <i class="fas fa-shopping-bag" aria-hidden="true"></i>
                    افزودن به لیست پرداخت
                  </button>
                </div>
              </template>
            </vue-bootstrap4-table>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>

    <modal-custom>
      <template v-slot:ContentModalSuccess>
        <taahodat-riz
          v-if="$store.state.renderComponent"
          @SumMablagh="SumMablagh"
          @SumMablaghJarime="SumMablaghJarime"
          @ListTaahodatRiz="ListTaahodatRiz"
          :taahodatId="TaahodatIdForGetRiz"
        ></taahodat-riz>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import ModalCustom from '../Tools/ModalCustom.vue'
import TaahodatRiz from './TaahodatRiz.vue'
import loading from '../Tools/NetPa/Loading.vue'
export default {
  components: {
    Panel,
    NetPaCard,
    VueBootstrap4Table,
    ModalCustom,
    TaahodatRiz,
    loading,
  },
  data() {
    return {
      IsFixVarizGorohi:false,
      IsFixVarizGorohiHasJarime :false,
      loadingRender: false,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },

      AccountList: [],
      ChildsAccountList: [],

      LoanList: [],
      ChildsLoanList: [],
      loanCardSearch: '',
      loanCardPage: 1,
      childLoanCardSearch: '',
      childLoanCardPage: 1,
      accountCardSearch: '',
      accountCardPage: 1,
      childAccountCardSearch: '',
      childAccountCardPage: 1,
      cardPerPage: 10,

      columnsAccount: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'نوع حساب',
          name: 'desNoe',
        },
        {
          label: 'شماره حساب',
          name: 'vCode',
        },
        {
          label: 'تاریخ افتتاح حساب',
          name: 'tarix',
        },
        {
          label: 'موجودی',
          name: 'mande',
        },
        {
          label: 'قابل برداشت',
          name: 'ghabelBardasht',
        },
        {
          label: 'مبلغ واریزی',
          name: 'MabVarizi',
        },
        {
          label: 'عملیات',
          name: 'Action',
        },
      ],
      ChildscolumnsAccount: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'مشخصات',
          name: 'nameFamily',
        },
        {
          label: 'نوع حساب',
          name: 'desNoe',
        },
        {
          label: 'شماره حساب',
          name: 'vCode',
        },
        {
          label: 'تاریخ افتتاح حساب',
          name: 'tarix',
        },
        {
          label: 'موجودی',
          name: 'mande',
        },
        {
          label: 'قابل برداشت',
          name: 'ghabelBardasht',
        },
        {
          label: 'مبلغ واریزی',
          name: 'MabVarizi',
        },
        {
          label: 'عملیات',
          name: 'Action',
        },
      ],

      columnsLoan: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },

        {
          label: 'نوع ',
          name: 'desNoe',
        },
        {
          label: 'شماره ',
          name: 'vCode',
        },
        {
          label: ' شروع اقساط',
          name: 'tarixShoroAghsat',
        },
        {
          label:this.$GetIsAnbohSaz()=='false' ?'مبلغ تسهیلات':'مبلغ قرارداد',
          name: 'mablaghVam',
        },
        {
          label: 'مبلغ قسط',
          name: 'mablaghGhestVam',
        },
        {
          label: 'مانده',
          name: 'mande',
        },
        {
          label: 'مجموع معوق',
          name: 'sumMabMoavaghe',
        },
        {
          label: 'جریمه',
          name: 'wwwJarime',
        },
        {
          label: 'مبلغ قابل پرداخت',
          name: 'SumGhabelPar',
        },
        {
          label: 'عملیات',
          name: 'Action',
        },
      ],
      ChildscolumnsLoan: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'مشخصات',
          name: 'nameFamily',
        },
        {
          label: 'نوع ',
          name: 'desNoe',
        },
        {
          label: 'شماره ',
          name: 'vCode',
        },
        {
          label: ' شروع اقساط',
          name: 'tarixShoroAghsat',
        },
        {
          label: 'مبلغ تسهیلات',
          name: 'mablaghVam',
        },
        {
          label: 'مبلغ قسط',
          name: 'mablaghGhestVam',
        },
        {
          label: 'مانده',
          name: 'mande',
        },
        {
          label: 'مجموع معوق',
          name: 'sumMabMoavaghe',
        },
        {
          label: 'جریمه',
          name: 'wwwJarime',
        },
        {
          label: 'مبلغ قابل پرداخت',
          name: 'SumGhabelPar',
        },
        {
          label: 'عملیات',
          name: 'Action',
        },
      ],

      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },

      TaahodatIdForGetRiz: null,
      IsChild: false,
      SumAllGhabelParLoan: 0,
      SumAllGhabelParChildLoan: 0,
    }
  },
  computed: {
    filteredLoanCards() {
      return this.filterRows(this.LoanList, this.loanCardSearch, [
        'desNoe',
        'vCode',
        'tarixShoroAghsat',
        'mablaghVam',
        'mablaghGhestVam',
        'mande',
        'sumMabMoavaghe',
        'wwwJarime',
        'SumGhabelPar',
      ])
    },
    pagedLoanCards() {
      return this.pageRows(this.filteredLoanCards, this.loanCardPage)
    },
    loanCardPageCount() {
      return this.pageCountOf(this.filteredLoanCards)
    },
    filteredChildLoanCards() {
      return this.filterRows(this.ChildsLoanList, this.childLoanCardSearch, [
        'nameFamily',
        'desNoe',
        'vCode',
        'tarixShoroAghsat',
        'mablaghVam',
        'mablaghGhestVam',
        'mande',
        'sumMabMoavaghe',
        'wwwJarime',
        'SumGhabelPar',
      ])
    },
    pagedChildLoanCards() {
      return this.pageRows(this.filteredChildLoanCards, this.childLoanCardPage)
    },
    childLoanCardPageCount() {
      return this.pageCountOf(this.filteredChildLoanCards)
    },
    filteredAccountCards() {
      return this.filterRows(this.AccountList, this.accountCardSearch, [
        'desNoe',
        'vCode',
        'tarix',
        'mande',
        'ghabelBardasht',
        'MabVarizi',
      ])
    },
    pagedAccountCards() {
      return this.pageRows(this.filteredAccountCards, this.accountCardPage)
    },
    accountCardPageCount() {
      return this.pageCountOf(this.filteredAccountCards)
    },
    filteredChildAccountCards() {
      return this.filterRows(
        this.ChildsAccountList,
        this.childAccountCardSearch,
        ['nameFamily', 'desNoe', 'vCode', 'tarix', 'mande', 'ghabelBardasht', 'MabVarizi'],
      )
    },
    pagedChildAccountCards() {
      return this.pageRows(this.filteredChildAccountCards, this.childAccountCardPage)
    },
    childAccountCardPageCount() {
      return this.pageCountOf(this.filteredChildAccountCards)
    },
  },
  watch: {
    LoanList() {
      this.loanCardPage = 1
    },
    loanCardSearch() {
      this.loanCardPage = 1
    },
    ChildsLoanList() {
      this.childLoanCardPage = 1
    },
    childLoanCardSearch() {
      this.childLoanCardPage = 1
    },
    AccountList() {
      this.accountCardPage = 1
    },
    accountCardSearch() {
      this.accountCardPage = 1
    },
    ChildsAccountList() {
      this.childAccountCardPage = 1
    },
    childAccountCardSearch() {
      this.childAccountCardPage = 1
    },
  },
  methods: {
    cardValue(val) {
      if (val == null || val === '') return '—'
      return val
    },
    filterRows(rows, q, keys) {
      const query = (q || '').trim().toLowerCase()
      const list = rows || []
      if (!query) return list
      return list.filter((row) => {
        const hay = keys
          .map((key) => row[key])
          .filter((v) => v != null && v !== '')
          .join(' ')
          .toLowerCase()
        return hay.includes(query)
      })
    },
    pageRows(rows, page) {
      const start = (page - 1) * this.cardPerPage
      return rows.slice(start, start + this.cardPerPage)
    },
    pageCountOf(rows) {
      return Math.max(1, Math.ceil((rows.length || 0) / this.cardPerPage))
    },
    isLoanAmountDisabled(row) {
      return (
        this.IsFixVarizGorohi === 'true' ||
        (this.IsFixVarizGorohiHasJarime === 'true' && row && row.wwwJarime > 0)
      )
    },
    isLoanPlanDisabled(row) {
      return this.IsFixVarizGorohiHasJarime === 'true' && row && row.wwwJarime > 0
    },
    GetTaahodat(IsAccount) {
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      if (IsAccount == true) formData.append('wwwtblSarfaslTypeId', 2)
      else formData.append('wwwtblSarfaslTypeId', 1)

      this.DataAxiosRow.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (IsAccount) {
          this.AccountList = data.filter((x) => x.isPayment == true && x.tblSarfaslTypeId != 6)
          this.EditRowsAccount(this.AccountList)
        } else {
          this.LoanList = data.filter((x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0)

          this.EditRowsLoan(this.LoanList)
          this.SumGhabelParLoan(this.LoanList)
        }
      })
    },
    GetTaahodatSahebHesab(IsAccount) {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      if (IsAccount == true) formData.append('wwwtblSarfaslTypeId', 2)
      else formData.append('wwwtblSarfaslTypeId', 1)

      this.DataAxios_SahebHesab.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
        if (IsAccount) {
          //  this.ChildsAccountList=data.filter(x=>x.mande>0)
          this.ChildsAccountList = data.filter((x) => x.isPayment == true && x.tblSarfaslTypeId != 6)
          this.EditRowsAccount(this.ChildsAccountList)
        } else {
          this.ChildsLoanList = data.filter((x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0)
          this.EditRowsLoan(this.ChildsLoanList)
          this.SumGhabelParChildLoan(this.ChildsLoanList)
        }
        this.loadingRender = false
      })
    },
    AddToCart(row, IsAccount) {
      let sumRiz = 0
      if (row.ListTaahodatRiz) {
        sumRiz = this.SumMabTaahodatRiz(row.ListTaahodatRiz)
      }
      if (IsAccount == true) {
        if(typeof(row.MabVarizi)=='number'){
          row.MabVarizi=this.$Comma3ragham(row.MabVarizi)
        }
        if (Number(row.MabVarizi.replace(/,/g, '')) > 0) {
          row.SumGhabelPar = Number(row.MabVarizi.replace(/,/g, ''))
          this.$Netpa_AddToCart(row, 'Account', 'حساب ها')
        } else {
          this.$mySweetDefaultTost('', 'مبلغ واریزی خالی می باشد لطفا مبلغ واریزی را تکمیل و سپس دوباره تلاش کنید', 'warning', 3000)
        }
      }
      if (IsAccount == false) {
        if (row.SumGhabelPar == '' || row.SumGhabelPar == '0') {
          row.SumGhabelPar = row.sumGhabelPar
        } else {
          if (Number((row.SumGhabelPar + '').replaceAll(/,/g, '')) < Number(row.CheckUpMablagh)) {
            var MablaghJarime = row.wwwJarime
            var MabFormulaJarime=0;
            if (this.$session.get('CustCode') == 561){
               MabFormulaJarime = (Number((row.SumGhabelPar + '').replaceAll(/,/g, '')) / (Number(row.CheckUpMablagh))) * MablaghJarime
            }
            else{
               MabFormulaJarime = (Number((row.SumGhabelPar + '').replaceAll(/,/g, '')) / (Number(row.CheckUpMablagh) - MablaghJarime)) * MablaghJarime
            }
            row.wwwJarime = Math.floor(MabFormulaJarime)
          }
          row.SumGhabelPar = Number((row.SumGhabelPar + '').replaceAll(/,/g, ''))
        }
        if (Number(row.sumMabTaeedNaShode)>0) {
          this.$mySweetDefaultTost('', ' برای تسهیلات' + this.$b_InvertCode(row.vCode, '-') + ' پرداختی تایید نشده  وجود دارد ، لطفا در روز های آتی دوباره اقدام به پرداخت نمایید', 'warning', 5000)
          return;
        }
        if (Number(row.SumGhabelPar) > Number(row.mande + row.wwwJarime) - Number(row.sumMabTaeedNaShode)) {
          this.$mySweetDefaultTost('', ' مبلغ قابل پرداخت وارد شده برای تسهیلات ' + this.$b_InvertCode(row.vCode, '-') + ' بیشتر از مانده تسهیلات می باشد ', 'warning', 3000)
        } else {
          // this.SumJarimeAndMablaghGhestVam(row);
          if (row.SumGhabelPar != sumRiz && sumRiz > 0) {
            row.ListTaahodatRiz = []
          } else this.$Netpa_AddToCart(row, 'Loan', 'تسهیلات')
        }
      }
    },
    EditRowsAccount(listRow) {
      for (let index = 0; index < listRow.length; index++) {
        if(listRow[index].sumGhabelPar==0 && listRow[index].mablaghSharj==0){
          listRow[index].MabVarizi = 0
        }
        if(listRow[index].sumGhabelPar==0 && listRow[index].mablaghSharj>0){
          listRow[index].MabVarizi = listRow[index].mablaghSharj
        }
        if(listRow[index].sumGhabelPar>0 ){
          listRow[index].MabVarizi = listRow[index].sumGhabelPar
        }
      }
    },
    EditRowsLoan(listRow) {
      for (let index = 0; index < listRow.length; index++) {
        listRow[index].SumGhabelPar = listRow[index].sumGhabelPar
        listRow[index].CheckUpMablagh = listRow[index].sumGhabelPar
      }
    },
    SumJarimeAndMablaghGhestVam(row) {
      row.mablaghGhestVam = Number(row.mablaghGhestVam) + Number(row.wwwJarime == null ? 0 : row.wwwJarime)
    },
    GetTaahodatRiz(row, IsChild) {
      this.TaahodatIdForGetRiz = row.id

      this.IsChild = IsChild

      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponent = true
      })
    },
    SumMablagh(val) {
      if (this.IsChild == true) {
        for (let index = 0; index < this.ChildsLoanList.length; index++) {
          if (this.ChildsLoanList[index].id == this.TaahodatIdForGetRiz) {
            this.ChildsLoanList[index].SumGhabelPar = val
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          }
        }
        this.SumGhabelParChildLoan(this.ChildsLoanList)
      } else {
        for (let index = 0; index < this.LoanList.length; index++) {
          if (this.LoanList[index].id == this.TaahodatIdForGetRiz) {
            this.LoanList[index].SumGhabelPar = Number(val)
            // this.$store.state.renderComponentGrid = false;
            // this.$nextTick(() => {
            //     this.$store.state.renderComponentGrid = true;
            //  });
          }
        }
        this.SumGhabelParLoan(this.LoanList)
      }
    },
    SumMablaghJarime(val) {
      if (this.IsChild == true) {
        for (let index = 0; index < this.ChildsLoanList.length; index++) {
          if (this.ChildsLoanList[index].id == this.TaahodatIdForGetRiz) {
            this.ChildsLoanList[index].wwwJarime = val
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          }
        }
        this.SumGhabelParChildLoan(this.ChildsLoanList)
      } else {
        for (let index = 0; index < this.LoanList.length; index++) {
          if (this.LoanList[index].id == this.TaahodatIdForGetRiz) {
            this.LoanList[index].wwwJarime = val
          }
        }
        this.SumGhabelParLoan(this.LoanList)
      }
    },
    ListTaahodatRiz(listRiz) {
      let sumRiz = this.SumMabTaahodatRiz(listRiz)
      if (this.IsChild == true) {
        for (let index = 0; index < this.ChildsLoanList.length; index++) {
          if (this.ChildsLoanList[index].id == this.TaahodatIdForGetRiz) {
            this.ChildsLoanList[index].ListTaahodatRiz = listRiz
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          }
        }
        for (let index = 0; index < this.ChildsAccountList.length; index++) {
          if (this.ChildsAccountList[index].id == this.TaahodatIdForGetRiz) {
            this.ChildsAccountList[index].ListTaahodatRiz = sumRiz
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          }
        }
        this.SumGhabelParChildLoan(this.ChildsLoanList)
      }
      else {
        for (let index = 0; index < this.LoanList.length; index++) {
          if (this.LoanList[index].id == this.TaahodatIdForGetRiz) {
            this.LoanList[index].ListTaahodatRiz = listRiz
          }
        }
        for (let index = 0; index < this.AccountList.length; index++) {
          if (this.AccountList[index].id == this.TaahodatIdForGetRiz) {
            this.AccountList[index].MabVarizi = sumRiz
            //console.log("😎 ", this.AccountList[index])
          }
        }
        this.SumGhabelParLoan(this.LoanList)
        // this.SumGhabelParAccount(this.AccountList)
      }
    },
    AllAddToCart(Arr) {
      var Ok = true
      for (let index = 0; index < Arr.length; index++) {
        if (Number((Arr[index].SumGhabelPar + '').replace(/,/g, '')) > Number(Arr[index].mande) + Arr[index].wwwJarime - Arr[index].sumMabTaeedNaShode) {
          Ok = false
        }
        if (Arr[index].SumGhabelPar == '' || Arr[index].SumGhabelPar == '0') {
          Ok = false
        }
      }
      if (Ok == true) {
        for (let index = 0; index < Arr.length; index++) {
          if (typeof Arr[index].SumGhabelPar == 'string') {
            Arr[index].SumGhabelPar = Number((Arr[index].SumGhabelPar + '').replace(/,/g, ''))
          }
          if (Number(Arr[index].SumGhabelPar) < Number(Arr[index].CheckUpMablagh)) {
            var MablaghJarime = Arr[index].wwwJarime
            var MabFormulaJarime=0;
            if (this.$session.get('CustCode') == 561){
               MabFormulaJarime = (Number(Arr[index].SumGhabelPar) / (Number(Arr[index].CheckUpMablagh))) * MablaghJarime
            }
            else{
               MabFormulaJarime = (Number(Arr[index].SumGhabelPar) / (Number(Arr[index].CheckUpMablagh) - MablaghJarime)) * MablaghJarime
            }
            Arr[index].wwwJarime = Math.floor(MabFormulaJarime)
          }
          this.$Netpa_AddToCart(Arr[index], 'Loan', 'تسهیلات')
        }
      } else {
        for (let index = 0; index < Arr.length; index++) {
          if (Number((Arr[index].SumGhabelPar + '').replace(/,/g, '')) > Number(Arr[index].mande) + Number(Arr[index].wwwJarime) - Arr[index].sumMabTaeedNaShode) {
            this.$mySweetDefaultTost('', ' مبلغ قابل پرداخت وارد شده برای تسهیلات ' + this.$b_InvertCode(Arr[index].vCode, '-') + ' بیشتر از مانده تسهیلات می باشد ', 'warning', 3000)
            return
          } else {
            this.$mySweetDefaultTost('', ' مبالغ قابل پرداختی شما نمی تواند خالی باشد', 'warning', 3000)
          }
        }
      }
    },
    SumGhabelParLoan(listRow) {
      this.SumAllGhabelParLoan = 0
      for (let index = 0; index < listRow.length; index++) {
        this.SumAllGhabelParLoan += Number(listRow[index].SumGhabelPar.toString().replace(/,/g, ''))
      }
      this.$PutCommatoInput()
    },
    SumGhabelParChildLoan(listRow) {
      //console.log("😎 ~ SumGhabelParChildLoan ~ listRow:", listRow)
      this.SumAllGhabelParChildLoan = 0
      for (let index = 0; index < listRow.length; index++) {
        this.SumAllGhabelParChildLoan += Number(listRow[index].SumGhabelPar.toString().replace(/,/g, ''))
      }
      
    },
    reverseString(str) {
      // Step 1. Use the split() method to return a new array
      var splitString = str.split('') // var splitString = "hello".split("");
      // ["h", "e", "l", "l", "o"]

      // Step 2. Use the reverse() method to reverse the new created array
      var reverseArray = splitString.reverse() // var reverseArray = ["h", "e", "l", "l", "o"].reverse();
      // ["o", "l", "l", "e", "h"]

      // Step 3. Use the join() method to join all elements of the array into a string
      var joinArray = reverseArray.join('') // var joinArray = ["o", "l", "l", "e", "h"].join("");
      // "olleh"

      //Step 4. Return the reversed string
      return joinArray // "olleh"
    },
    SumMabTaahodatRiz(list) {
      let sum = 0
      for (let index = 0; index < list.length; index++) {
        sum += Number(list[index].mablaghGhest) + (Number(list[index].mabJarime) - Number(list[index].mabBakhshesh))
      }
      return sum
    },
  },
  created() {
    this.IsFixVarizGorohi= this.$GetIsEstelamCodeMeli()
  },
  mounted() {
    this.$store.state.ListTaahodatRizInCart = []
    this.$PutCommatoInput()
    this.GetTaahodat(true)
    this.GetTaahodat(false)

    this.GetTaahodatSahebHesab(true)
    this.GetTaahodatSahebHesab(false)
  },
  updated() {
    this.$PutCommatoInput()
  },
}
</script>
<style scoped>
.deposit-group-amount {
  width: 8.5rem;
  max-width: 100%;
  height: 36px;
  margin: 0 auto;
  padding: 0.25rem 0.55rem;
  color: #29345f;
  font-size: 13px !important;
  font-weight: 700;
  direction: ltr;
  text-align: center;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

.deposit-group-amount:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.deposit-group-amount:disabled {
  color: #8a96a3;
  background: #f8fafc;
}

.deposit-group-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.35rem;
}

.deposit-group-actions:has(> :only-child) {
  justify-content: center;
}

.deposit-group-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 32px;
  margin: 0;
  padding: 0.25rem 0.7rem;
  border: 1px solid;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(41, 52, 95, 0.05);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease, box-shadow 0.15s ease;
}

.deposit-group-chip i {
  flex-shrink: 0;
  font-size: 11px;
}

.deposit-group-chip:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.deposit-group-chip:disabled {
  color: #8a96a3;
  border-color: #e8eef2;
  background: #f4f6f8;
  cursor: not-allowed;
  box-shadow: none;
}

.deposit-group-chip--plan {
  color: #9a6b16;
  border-color: #eed9b0;
  background: #fdf8ef;
}

.deposit-group-chip--plan:not(:disabled):hover,
.deposit-group-chip--plan:not(:disabled):focus {
  color: #7a5410;
  border-color: #c7922c;
  background: #f8edd6;
}

.deposit-group-chip--add {
  color: #2f7a1f;
  border-color: #b7dfb0;
  background: #eef8ec;
}

.deposit-group-chip--add:hover,
.deposit-group-chip--add:focus {
  color: #166c3b;
  border-color: #2f7a1f;
  background: #e6f6ee;
}

.deposit-group-chip--add-all {
  min-height: 40px;
  padding: 0.45rem 1rem;
  color: #fff;
  border: 0;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 8px 18px rgba(41, 52, 95, 0.16);
}

.deposit-group-chip--add-all:hover,
.deposit-group-chip--add-all:focus {
  color: #fff;
}

.deposit-group-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.85rem;
  padding-top: 0.85rem;
  border-top: 1px solid #e8eef2;
}

.deposit-group-sum {
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
}

.deposit-group-sum strong {
  margin-right: 0.35rem;
  color: #8d58a4;
  font-size: 15px;
}

@media (max-width: 767px) {
  .deposit-group-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .deposit-group-chip--add-all,
  .deposit-group-actions .deposit-group-chip {
    width: 100%;
  }
}

.deposit-group-cards {
  display: none;
}

.deposit-group-cards__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.85rem;
}

.deposit-group-cards__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

.deposit-group-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.deposit-group-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.deposit-group-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.deposit-group-card {
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
  text-align: right;
}

.deposit-group-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.55rem;
}

.deposit-group-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.deposit-group-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  border-radius: 999px;
  color: #287db4;
  background: #edf5fb;
  font-size: 12px;
  font-weight: 800;
}

.deposit-group-card__amount {
  margin: 0 0 0.75rem;
  color: #29345f;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
}

.deposit-group-card__amount small {
  margin-right: 0.3rem;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.deposit-group-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.deposit-group-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.deposit-group-card__field--input {
  align-items: center;
}

.deposit-group-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.deposit-group-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.deposit-group-card__field .deposit-group-amount {
  width: 8.5rem;
  margin: 0;
}

.deposit-group-card__actions {
  margin-top: 0.75rem;
}

.deposit-group-cards__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

.deposit-group-cards__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.deposit-group-cards__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.deposit-group-cards__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .deposit-group-cards {
    display: block;
  }

  .deposit-group-table-view {
    display: none;
  }

  .deposit-group-card__field .deposit-group-amount {
    width: 100%;
    max-width: 10rem;
  }
}
</style>
<style>
#DepositGroup .netpa-card {
  margin-bottom: 0.75rem;
}

#DepositGroup .netpa-card__header h6 {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0;
  color: #29345f;
  font-size: 15px;
  font-weight: 800;
}

#DepositGroup .netpa-card__header h6 i {
  color: #56508d;
}

#DepositGroup .netpa-card__body {
  padding-top: 0.85rem !important;
}
</style>
